<template>
    <div>
        <page-header :heading="pageHeader.title"
                     :buttons="pageHeader.buttons" />
        <div class="border rounded p-1">
            <h3>Settlement Options - Matrix</h3>
            <div class="form-row align-items-center">
                <div class="col-auto">
                    <label class="sr-only" for="resellerId">Reseller</label>
                    <input type="text" class="form-control mb-2" id="resellerId" placeholder="Reseller ID" v-model="payload.resellerId" v-on:input="handleChangeEvent" v-on:keyup.enter="handleKeyUp">
                </div>
                <div class="col-auto">
                    <label class="sr-only" for="deviceTypeId">Device Type</label>
                    <input type="text" class="form-control mb-2" id="deviceTypeId" placeholder="Device Type ID" v-model="payload.deviceTypeId" v-on:input="handleChangeEvent" v-on:keyup.enter="handleKeyUp">
                </div>
                <div class="col-auto">
                    <label class="sr-only" for="deviceMakeId">Device Make ID</label>
                    <input type="text" class="form-control mb-2" id="deviceMakeId" placeholder="Device Make ID" v-model="payload.deviceMakeId" v-on:input="handleChangeEvent" v-on:keyup.enter="handleKeyUp">
                </div>
                <div class="col-auto">
                    <label class="sr-only" for="deviceModelId">Device Model ID</label>
                    <input type="text" class="form-control mb-2" id="deviceModelId" placeholder="Device Model ID" v-model="payload.deviceModelId" v-on:input="handleChangeEvent" v-on:keyup.enter="handleKeyUp">
                </div>
                <div class="col-auto">
                    <label class="sr-only" for="incidentTypeId">Incident Type ID</label>
                    <input type="text" class="form-control mb-2" id="incidentTypeId" placeholder="Incident Type ID" v-model="payload.incidentTypeId" v-on:input="handleChangeEvent" v-on:keyup.enter="handleKeyUp">
                </div>
                <div class="col-auto">
                    <button type="submit" class="btn btn-primary mb-2" v-on:click="handleRunClick" :disabled="runButtonDisabled">Run</button>
                </div>
            </div>
            <div v-if="loading == true" class="d-flex justify-content-center">
                <div class="spinner-border mt-2" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
            <table class="table mt-2" v-if="results && results.length > 0 &&  runClicked == true && loading == false">
                <thead>
                    <tr>
                        <th scope="col">Option Type</th>
                        <th scope="col">Partner</th>
                        <th scope="col">Weighting %</th>
                        <th scope="col">Device Damage ID</th>
                        <th scope="col">Repair Device Damage ID</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(opt, idx) in results" :key="'options_' + idx">
                        <th scope="row">{{opt.repairOptionTypeLabel}}</th>
                        <td>{{opt.repairProviderLabel}}</td>
                        <td>{{opt.providerWeighting}}</td>
                        <td>{{opt.deviceDamageLinkId}}</td>
                        <td>{{opt.id}}</td>
                    </tr>
                </tbody>
            </table>
            <div class="mt-2" v-else-if="runClicked == true && loading == false">
                <span>No results...</span>
            </div>
        </div>
        <div class="border rounded p-1 mt-2">
            <h3>Resellers - Email branding</h3>
            <div class="form-row align-items-center">
                <div class="col-auto">
                    <label class="sr-only" for="resellerId2">Reseller</label>
                    <select class="form-control mb-2" id="resellerId2" v-model="resellerId" v-on:focus="resellerId = null; emailBranding = null; emailBrandingRunClicked = false">
                        <option :value="null">SELECT...</option>
                        <option v-for="(r, i) in resellers" :key="'reseller-select-' + i" :value="r.id">{{r.name}}</option>
                    </select>
                </div>
                <div class="col-auto">
                    <div class="col-auto">
                        <button type="submit" class="btn btn-primary mb-2" v-on:click="handleEmailBrandingRunClick" :disabled="emailBrandingRunButtonDisabled">View</button>
                    </div>
                </div>
            </div>
            <div v-if="emailBrandingLoading == true" class="d-flex justify-content-center">
                <hr />
                <div class="spinner-border mt-2" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
            <div v-if="emailBranding &&  emailBrandingRunClicked == true && emailBrandingLoading == false">
                <hr />
                <dl class="row mt-2">
                    <dt class="col-sm-3">Website</dt>
                    <dd class="col-sm-9">{{emailBranding.website}}</dd>
                    <dt class="col-sm-3">Email</dt>
                    <dd class="col-sm-9">{{emailBranding.email}}</dd>
                    <dt class="col-sm-3">Telephone</dt>
                    <dd class="col-sm-9">{{emailBranding.telephone}}</dd>
                    <dt class="col-sm-3">Signature</dt>
                    <dd class="col-sm-9">{{emailBranding.signature}}</dd>
                    <dt class="col-sm-3">LegalText</dt>
                    <dd class="col-sm-9">{{emailBranding.legalText}}</dd>
                    <dt class="col-sm-3">Logo</dt>
                    <dd class="col-sm-9"><img :src="'data:image/png;base64, ' + emailBranding.logoBase64Encoded" alt="Logo" class="img-thumbnail" /></dd>
                </dl>
            </div>
            <div class="mt-2" v-else-if="emailBrandingRunClicked == true && emailBrandingLoading == false">
                <hr />
                <span>No results...</span>
            </div>
        </div>
    </div>
</template>

<script>

    import { repairOptionApiService } from '@/services/repairOption-api.service'
    import { resellerApiService } from '@/services/reseller-api.service'
    
    import PageHeader from '@/components/PageHeader.vue'

    export default {
        name: 'SettlementOptionsMatrix',
        mixins: [],
        components: {
            PageHeader
        },
        data: () => {
            return {
                pageHeader: {
                    title: 'Util',
                },
                payload: {
                    resellerId: null,
                    deviceTypeId: null,
                    deviceMakeId: null,
                    deviceModelId: null,
                    incidentTypeId: null
                },
                results: [],
                runClicked: false,
                loading: false,

                resellerId: null,
                emailBrandingRunClicked: false,
                resellers: [],
                emailBranding: null,
                emailBrandingLoading: false
            }
        },
        beforeMount() {
            resellerApiService.getResellers()
                .then((response) => {
                    this.resellers = response.data.data
                })
                .catch((error) => {
                    console.error(error)
                })
                .finally(() => this.emailBrandingLoading = false)
        },
        watch: {
            //resellerId: function (newVal, oldVal) {
            //    this.emailBranding = null
            //}
        },
        computed: {
            runButtonDisabled() {
                let { payload } = this

                if (!payload) {
                    return true
                }

                if (!payload.resellerId || !payload.deviceTypeId || !payload.deviceMakeId || !payload.deviceModelId || !payload.incidentTypeId) {
                    return true
                }
                return false
            },
            emailBrandingRunButtonDisabled() {
                let { resellerId } = this

                if (resellerId == null) {
                    return true
                }
                return false
            }
        },
        methods: {
            handleRunClick() {
                let { payload } = this
                this.runClicked = true
                this.loading = true

                repairOptionApiService.queryMatrix(payload)
                    .then((response) => {
                        console.log(response)
                        this.results = response.data.data
                    })
                    .catch((error) => {
                        console.error(error)
                    })
                    .finally(() => this.loading = false)
            },
            handleChangeEvent(e) {
                this.runClicked = false
                if (this.results && this.results.length > 0) {
                    this.results = []
                }
            },
            handleKeyUp(e) {
                if (!this.runButtonDisabled) {
                    this.handleRunClick()
                }
            },
            handleEmailBrandingRunClick() {
                let { resellerId } = this
                this.emailBrandingRunClicked = true
                this.emailBrandingLoading = true

                resellerApiService.getEmailBrandingForReseller(resellerId)
                    .then((response) => {
                        console.log(response)
                        this.emailBranding = response.data.data
                    })
                    .catch((error) => {
                        console.error(error)
                    })
                    .finally(() => this.emailBrandingLoading = false)
            }
        }
    }
</script>

<style>
    button:disabled {
        cursor: not-allowed;
        pointer-events: all !important;
    }
</style>
